window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

if (typeof window.scriptLoaded === 'undefined') window.scriptLoaded = [];
if (window.scriptLoaded.includes('base-packages') === false)
    try {
        window.Popper = require('popper.js').default;
        window.$ = window.jQuery = require('jquery');
        window.Aos = window.AOS = require('aos');

        require('bootstrap');
        require('jquery-ui');
        require('jquery-mousewheel');
        require('@fortawesome/fontawesome-free');
        require('select2/dist/js/select2.full');
        require('../vendor/malihu-custom-scrollbar/jquery.mCustomScrollbar');
        require('../vendor/filemanager/stand-alone-button');
        window.scriptLoaded.push('base-packages');
    } catch (e) { }

window.ajaxSubmitForm = function (form_selector = '', postFormData = {}, callback = console.log) {
    let target_form = $(form_selector), form_data,
        send_options = { dataType: 'json', success: callback },
        send_data = {};
    if (target_form.length) {
        form_data = new FormData(target_form.get(0));
        for (let key of form_data.keys()) {
            if (key.indexOf('[]') > -1) {
                send_data[key] = form_data.getAll(key);
            } else {
                send_data[key] = form_data.get(key);
            }
        }
        if (postFormData) {
            Object.keys(postFormData).map(function (key) {
                send_data[key] = postFormData[key];
            });
        }
        send_options.type = target_form.attr('method');
        send_options.url = target_form.attr('action');
        send_options.data = send_data;
        $.ajax(send_options);
    }
    // console.log(send_options, send_data);
};

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

let base_url = document.head.querySelector('meta[name="base-url"]');

if (base_url) {
    window.base_url = base_url.content;
} else {
    window.base_url = '';
    console.error('base-url not found.');
}

let prev_url = document.head.querySelector('meta[name="prev-url"]');

if (prev_url) {
    window.prev_url = prev_url.content;
} else {
    window.prev_url = '';
    console.error('prev-url not found.');
}

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import TurbolinksAdapter from 'vue-turbolinks';
window.Vue.use(TurbolinksAdapter);
window.count = 0;
let app, vue_init_first = true;
let init_func = (exe_flag = true) => {
    console.log(`executed: ${count} times.`);
    console.log(`flag: ${exe_flag}, signal: ${vue_init_first}`);
    if (vue_init_first === exe_flag) {
        count++;
        document.querySelectorAll('a[href^="#"]').forEach(dom => {
            dom.setAttribute("data-turbolinks", false);
        });
        try {
            app = new Vue({
                el: 'div#vue-app',
            });
        } catch (e) {
            // console.error(e);
        }
    } else {
        vue_init_first = exe_flag;
    }
};
init_func();

document.addEventListener('turbolinks:load', () => {
    init_func(false);
});

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
